import React, { useState } from "react";
import "./AdvertPreview.css";
import { Col, Container, Row } from "react-bootstrap";
import useIsMobile from "../../../../lib/hooks/useIsMobile";
import { CollaspeButton } from "../../../redesign/viewLayout/sidePanel/collaspingPanel/CollaspeButton";

export const AdvertPreviewLayout = ({ children, showFilter = true }) => {
    const [collapsed, setCollapsed] = useState(false);
    const collapsingWidth = collapsed ? "auto" : 275;
    const isMobile = useIsMobile();

    return (
        <Container fluid>
            <Row className="flex-nowrap w-100">
                {!isMobile && showFilter && (
                    <div className="lhs-filter-container" style={{ width: collapsingWidth }}>
                        {!collapsed && <p className="lhs-filter-text">LHS Filter</p>}
                        <CollaspeButton collasped={collapsed} setCollasped={setCollapsed} />
                    </div>
                )}
                <Col className="px-2 overflow-x-hidden content-column">
                    <div className="advert-preview">
                        {children}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};
